module.exports = __webpack_public_path__ + "img/2.d04c9ddb.png";